import { Download1Stroke, Pencil1Stroke, PlusStroke, Search1Stroke, Trash3Stroke } from '@lineiconshq/free-icons';
import { Binoculars, FileDown, FileSpreadsheet, FileUp, Printer, RefreshCw, Table } from 'lucide-react';
import { ActionBarV2, ActionButtonV2, AritoColoredDot, MenuButtonV2 } from '@/components/custom/erp';

interface Props {
  onAddClick: () => void;
  onEditClick: () => void;
  onDeleteClick: () => void;
  onCopyClick: () => void;
  onViewClick: () => void;
  onRefreshClick: () => void;
  isEditDisabled?: boolean;
  className?: string;
  groupType?: string;
}

export function ActionBar({
  className,
  groupType,
  onAddClick,
  onEditClick,
  onDeleteClick,
  onCopyClick,
  onViewClick,
  onRefreshClick,
  isEditDisabled = true
}: Props) {
  return (
    <ActionBarV2
      titleComponent={
        <div className='flex items-center gap-2'>
          <div>
            <h1 className='text-xl font-bold'>Danh mục nhóm tài sản/công cụ</h1>
            {groupType && (
              <div className='flex flex-row items-center'>
                <AritoColoredDot color='maroon' />
                <div className='ml-2 text-sm text-gray-600'>{groupType}</div>
              </div>
            )}
          </div>
        </div>
      }
    >
      <div className={`grid gap-2 lg:flex ${className}`}>
        <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddClick} variant='primary' />
        <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditClick} disabled={isEditDisabled} />
        <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDeleteClick} disabled={isEditDisabled} />
        <ActionButtonV2 icon={Download1Stroke} title='Sao chép' onClick={onCopyClick} />
        <ActionButtonV2 icon={Search1Stroke} title='Xem' onClick={onViewClick} />
        <MenuButtonV2
          title='Khác'
          items={[
            {
              title: 'Tìm kiếm',
              icon: Binoculars,
              onClick: () => {},
              group: 0
            },
            {
              title: 'Refresh',
              icon: RefreshCw,
              onClick: onRefreshClick,
              group: 1
            },
            {
              title: 'Cố định cột',
              icon: Table,
              onClick: () => {},
              group: 1
            },
            {
              title: 'In nhiều',
              icon: Printer,
              onClick: () => {},
              group: 2
            },
            {
              title: 'Kết xuất dữ liệu',
              icon: FileDown,
              onClick: () => {},
              group: 2
            },
            {
              title: 'Tải mẫu Excel',
              icon: FileSpreadsheet,
              onClick: () => {},
              group: 3
            },
            {
              title: 'Lấy dữ liệu từ Excel',
              icon: FileUp,
              onClick: () => {},
              group: 3
            }
          ]}
        />
      </div>
    </ActionBarV2>
  );
}
